import React from 'react';
import {useGetCourseVideoQuery} from 'src/redux/queries/courseVideo';
import type {IFormFieldV2} from 'src/types/FormV2';
import {FormViewRowV2} from './FormViewRow/FormViewRowV2';

export interface FormViewVideoSelectorProps {
  field: IFormFieldV2;
  value: string | number | undefined;
}

export const FormViewVideoSelector: React.FC<FormViewVideoSelectorProps> = ({
  field,
  value,
}) => {
  const video = useGetCourseVideoQuery(Number(value));
  const label = `${video.data?.title ?? 'N/A'} - ${
    video.data?.description?.abbreviate(75) ?? 'N/A'
  }`;
  return <FormViewRowV2 field={field} value={label} />;
};
